import {Library} from './library.model';

export class LibraryList {

  count: any;

  libraries: Library[];


  constructor(attr: {count: number, libraries: any[]}) {
    this.count = attr.count;
    if (attr.libraries) {
      this.libraries = attr.libraries.map(lib => new Library(lib));
    }
  }
}
